import { useTranslateUserRole } from '@adamdotai/core/utils'
import {
    Avatar,
    Center,
    Heading,
    Spinner,
    Stack,
    Tag,
    Text,
    Tooltip,
} from '@adamdotai/design-system'
import { useQuery } from '@urql/next'
import { isEqual } from 'lodash'
import React, { useMemo } from 'react'
import { graphql } from '../../../../../../../generated/gql/gql'

const GET_USER = graphql(`query GetUser($userId: UUID!) {
    user(userId: $userId) {
        id
        email
        displayName
        firstName
        lastName
        imageUrl
        meetplaceId
        role
        jobTitle
    }
  }
  `)

type UserCardProps = {
    userId: string
}

export const UserCard = React.memo<UserCardProps>(
    ({ userId }) => {
        const [{ data: userQueryResult }] = useQuery({
            query: GET_USER,
            variables: { userId },
            requestPolicy: 'cache-first',
        })

        const { getUserRoleTranslatedName } = useTranslateUserRole()

        const roleName = useMemo(() => {
            if (userQueryResult?.user?.role) {
                return getUserRoleTranslatedName(userQueryResult.user.role)
            }
            return null
        }, [userQueryResult?.user?.role, getUserRoleTranslatedName])

        if (userQueryResult == null || userQueryResult.user == null)
            return (
                <Center w="280px" h="235px">
                    <Spinner label="" />
                </Center>
            )

        const { firstName, lastName, imageUrl, email, jobTitle } =
            userQueryResult.user
        const fullName = `${firstName} ${lastName}`

        return (
            <Stack spacing={2} alignItems="center" py={8} px={4} w={[66, 70]}>
                <Avatar src={imageUrl ?? undefined} name={fullName} size="xl" />
                <Stack spacing={1} alignItems="center">
                    <Tag w="18">{roleName}</Tag>
                    <Tooltip label={fullName?.length > 23 ? fullName : ''}>
                        <Heading textAlign="center" width={61} noOfLines={1}>
                            {fullName}
                        </Heading>
                    </Tooltip>
                    {jobTitle ? <Text size="caption">{jobTitle}</Text> : null}
                    <Tooltip label={email?.length > 33 ? email : ''}>
                        <Text
                            textAlign="center"
                            size="caption"
                            color="neutral"
                            width={61}
                            noOfLines={1}
                        >
                            {email}
                        </Text>
                    </Tooltip>
                </Stack>

                {/* <Flex gap={3}> */}
                {/*     <IconButton icon={<CopyIcon />} /> */}
                {/*     <IconButton tooltipProps={{label: "Email"}} icon={<EmailIcon />} /> */}
                {/*     <IconButton tooltipProps={{label: "Booking"}} icon={<CalendarIcon />} /> */}
                {/*     <IconButton tooltipProps={{label: "Send"}} icon={<SendIcon />} /> */}
                {/* </Flex> */}
            </Stack>
        )
    },
    (prevProps, nextProps) => isEqual(prevProps, nextProps),
)
UserCard.displayName = 'UserCard'
